import { axiosRequest } from "utils/api"

export default ({ signup, status, setSignupTimes, signupTimes }) => {
  /**
   * @param {{
   *   type: "maxAttendees" | "enableSplitReg" | "availableForReg"
   *   value: string | bool | object
   * }[]} optionsToSave
   */
  const handleOptionsUpdate = optionsToSave => {
    status.setSaving()
    return Promise.all(optionsToSave.map(option => optionUpdaterLookup[option.type](option.value)))
      .then(resp => {
        status.setSuccess()
        return resp
      })
      .catch(({ errors }) => {
        status.setError(errors)
        throw errors
      })
  }

  const optionUpdaterLookup = {
    maxAttendees: maxAttendees => {
      return signup.update({ maximum_registration_attendees: maxAttendees })
    },
    enableSplitReg: enableSplitReg => {
      return signup.update({ register_for_separate_times: enableSplitReg })
    },
    availableForReg: updatedEventTime => {
      return axiosRequest("patch", `events/${signup.id}/event_times/${updatedEventTime.id}`, {
        attributes: {
          available_for_registrations: updatedEventTime.availableForRegistrations
        }
      }).then(resp => {
        setSignupTimes(
          signupTimes.map(time => {
            if (time.id === updatedEventTime.id) {
              return updatedEventTime
            } else {
              return time
            }
          })
        )
        return resp
      })
    }
  }

  return handleOptionsUpdate
}
